import cx from '@travel/ui/utils/classnames';

import styles from './rating.module.scss';

type StarType = 'full' | 'half' | 'empty';

const Star = ({ index, type }: { index: number; type: StarType }) => (
  <img
    key={index}
    className={styles.star}
    alt={`${type}-star`}
    src={`https://img.travel.rakuten.co.jp/share/onsen/smart/images/${type}-star.svg`}
  />
);

const addStars = (rating: number) => {
  const starArray: JSX.Element[] = [];
  let i: number;
  for (i = 1; i <= Math.floor(rating); i++) {
    starArray.push(<Star key={i} index={i} type="full" />);
  }

  // Half or Full star
  const fractionalPart = rating % 1;
  if (fractionalPart >= 0.01 && fractionalPart <= 0.5) {
    starArray.push(<Star key={i} index={i} type="half" />);
    i += 0.5;
  } else if (fractionalPart > 0.5) {
    starArray.push(<Star key={i} index={i} type="full" />);
    i += 1;
  }

  // Empty star
  for (; i <= 5; i++) {
    starArray.push(<Star key={i} index={i} type="empty" />);
  }
  return starArray;
};

type Props = {
  rating: number | undefined;
  numReviews: number | undefined;
  className?: string;
  type?: 'PC' | 'SP' | 'skeleton';
};

const Rating = (props: Props) => {
  const { rating = 0, numReviews = 0, className = '', type = 'PC' } = props;
  const starArray = addStars(rating);

  const isRatingExist = rating > 0;
  const isReviewExist = numReviews > 0;
  const displayPrice = isRatingExist && isReviewExist;

  const formatRating = rating.toFixed(2);
  const formatNumReviews = new Intl.NumberFormat('ja-JP').format(numReviews);

  return (
    <div className={cx(styles.wrapper, className)} data-testid="rating-wrapper">
      {(isRatingExist || type === 'skeleton') && starArray}
      {isRatingExist && (
        <span className={styles.ratingScore} data-testid="Rating-rating-text">
          {formatRating}
        </span>
      )}
      {displayPrice && type === 'PC' && (
        <span className={styles.guestReview} data-testid="Rating-review-text-withTitle">
          ({formatNumReviews}件)
        </span>
      )}
      {displayPrice && type === 'SP' && (
        <span className={styles.guestReview} data-testid="Rating-review-text-withTitle">
          全{formatNumReviews}件
        </span>
      )}
    </div>
  );
};

export default Rating;
